var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 16.8311V1H10V16.8311M10 49.1689V65H54V49.1689",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14L35.5922 25.0557H47.2169L37.8123 31.8885L41.4046 42.9443L32 36.1115L22.5954 42.9443L26.1877 31.8885L16.7831 25.0557H28.4078L32 14Z",
    fill: "#845EC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7186 25.4271L55.3136 30.3358L55.482 30.8541H56.0269H61.1883L57.0126 33.8879L56.5718 34.2082L56.7402 34.7264L58.3351 39.6352L54.1595 36.6014L53.7186 36.2811L53.2778 36.6014L49.1021 39.6352L50.6971 34.7264L50.8655 34.2082L50.4246 33.8879L46.249 30.8541H51.4104H51.9553L52.1237 30.3358L53.7186 25.4271Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2811 25.4271L11.8761 30.3358L12.0445 30.8541H12.5894H17.7508L13.5751 33.8879L13.1343 34.2082L13.3027 34.7264L14.8976 39.6352L10.722 36.6014L10.2811 36.2811L9.84029 36.6014L5.66462 39.6352L7.25958 34.7264L7.42797 34.2082L6.98713 33.8879L2.81146 30.8541H7.97287H8.51777L8.68616 30.3358L10.2811 25.4271Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.091dd70bb9f8b8b99d887de2fd61c3a0.svg";
export { ForwardRef as ReactComponent };